import {Tabs, Card, Upload, message, Modal, Col, Row, Flex } from "antd";
import {
  AppleOutlined,
  AndroidOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
// import {Row, Col} from "react-bootstrap";
import EditProfile from "../../../pages/main/profile/EditProfile";
import {useEffect, useState} from "react";
import ChangePassword from "./settings/ChangePassword";
import { profileImageAsync, selectAccount } from "../../../app/store/reducers/auth/authReducer";
import { beforeUpload, getBase64 } from "../../../helper/Base64";
import { useSelector, useDispatch } from 'react-redux';
import { PATH_IMAGE } from "../../../helper/path";

// const getBase64 = (img, callback) => {
//   const reader = new FileReader();
//   reader.addEventListener("load", () => callback(reader.result));
//   reader.readAsDataURL(img);
// };

// const beforeUpload = (file) => {
//   const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
//   if (!isJpgOrPng) {
//     message.error("You can only upload JPG/PNG file!");
//   }
//   const isLt2M = file.size / 1024 / 1024 < 2;
//   if (!isLt2M) {
//     message.error("Image must smaller than 2MB!");
//   }
//   return isJpgOrPng && isLt2M;
// };








const Profile = () => {
  const account = useSelector(selectAccount)

  const items = [
    {
      icon: <AppleOutlined />,
      label: "Personal Details",
      children: <EditProfile />,
    },
    {
      icon: <AndroidOutlined />,
      label: "Change Password",
      children: <ChangePassword/>,
    },
  ];


  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [fileList, setFileList] = useState([])
  const handleChange = (info) => {
    setFileList(info?.fileList)
    console.log(info.file.status, "test");
    if (info?.file?.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info?.file?.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        const img = url?.split(",")[1]
        setLoading(false);
        setImageUrl(url);
        profileUpdateImage({
          base64: img,
          filename: info?.file?.name,
          size: info?.file?.size
        })
      });
    }

    if (info?.file?.status === "removed") {
      console.log("remove", account.image);
      profileUpdateImage({
        image_id: account?.image.id,
        path: account?.image?.path
      })
    }
  };
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (account?.image) { 
      // setImageUrl(PATH_PROFILE + account?.image?.path)
      setFileList([
        {
          uid: '1',
          name: account?.image?.filename,
          status: 'done',
          url: PATH_IMAGE + account?.image?.path,
        }
      ])
    }
  },[account])

  const profileUpdateImage = (file) => {
    profileImageAsync(file)
      .then((response) => {
        console.log("success image profile", response)
      })
      .catch((error) => {
        console.log("error image profile", error);
      })
  }

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
        //style={{height: "55vh"}}
  return (
    <>
      {/* <Row className="m-0"> */}

        <Card>
      <Flex align="center" justify="center" vertical>
          <Col className="d-flex justify-content-center align-items-center">
            <div>
              <Upload
                name="avatar"
                listType="picture-circle"
                // className="avatar-uploader"

                // showUploadList={false}
                fileList={fileList}
                // action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                beforeUpload={beforeUpload}
                onChange={handleChange}
                onPreview={() => setShow(true)}
                // onRemove={(e) => console.log(e)}
              >
                {/* {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt="avatar"
                    style={{
                      width: "100%",
                    }}
                  />
                ) : (
                  uploadButton
                )} */}
                {fileList?.length > 0 ? null : uploadButton}
              </Upload>
              <Modal open={show} title="image" footer={null} onCancel={() => setShow(false)}>
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={fileList[0]?.url}
        />
      </Modal>
            </div>
          </Col>
          {/* <Col className="d-inline-flex justify-content-center"> */}
          <Col>
            <Tabs
              defaultActiveKey="0"
              onChange={(e) => console.log("e", e)}
              type="card"
              centered
              items={items.map((item, i) => {
                return {
                  key: `${i}`,
                  label: item?.label,
                  children: item?.children,
                };
              })}
            />
          </Col>
      </Flex>
        </Card>
      {/* </Row> */}
    </>
  );
};

export default Profile;
